import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../constants/theme';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingContainer = styled.div<{ minHeight?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${props => props.minHeight || '200px'};
  flex-direction: column;
  gap: 16px;
`;

const Spinner = styled.div<{ size?: number }>`
  width: ${props => props.size || 32}px;
  height: ${props => props.size || 32}px;
  border: 2px solid ${colors.background.tertiary};
  border-top: 2px solid ${colors.primary.main};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const LoadingText = styled.p`
  color: ${colors.text.secondary};
  font-size: 0.9rem;
  margin: 0;
  text-align: center;
`;

interface InlineLoadingProps {
  message?: string;
  size?: number;
  minHeight?: string;
}

/**
 * Compact loading indicator for inline use within components
 * Perfect for permission checks, data loading, etc.
 */
const InlineLoading: React.FC<InlineLoadingProps> = ({ 
  message = "Loading...", 
  size = 32,
  minHeight = "200px"
}) => {
  return (
    <LoadingContainer minHeight={minHeight}>
      <Spinner size={size} />
      <LoadingText>{message}</LoadingText>
    </LoadingContainer>
  );
};

export default InlineLoading;
